import React, { useEffect, useState } from "react";
import { useTitle } from "../../context/TitleContext";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addCategory, clearAddCategoryState, fetchCategories } from "../../redux/Slices/CategorySlice";
import { validateFieldLanguage } from "../../Utils/languageValidation";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowLeft, FaLayerGroup } from "react-icons/fa";

const AddCategory = () => {
  const { t, i18n } = useTranslation("global");
  const { setTitle } = useTitle();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: categories, addLoading, addError, addSuccessMessage } = useSelector((state) => state.categories);

  const [formData, setFormData] = useState({
    name_ar: "",
    name_en: "",
    status: "",
  });

  useEffect(() => {
    setTitle(t("sidenav.addCategory"));
    if (!categories || categories.length === 0) {
      dispatch(fetchCategories());
    }
  }, [setTitle, t, i18n.language, dispatch, categories]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // BUG-11 fix: التحقق من لغة الحقول قبل الإرسال
    const arError = validateFieldLanguage(formData.name_ar, "ar");
    if (arError) return toast.error(arError);
    const enError = validateFieldLanguage(formData.name_en, "en");
    if (enError) return toast.error(enError);

    // التحقق من عدم تكرار اسم الفئة (عربي أو إنجليزي)
    const isDuplicateAr = Array.isArray(categories) && categories.some(
      (c) => c.name_ar.trim().toLowerCase() === formData.name_ar.trim().toLowerCase()
    );
    if (isDuplicateAr) {
      return toast.error("اسم الفئة بالعربي مكرر بالفعل");
    }

    const isDuplicateEn = Array.isArray(categories) && categories.some(
      (c) => c.name_en.trim().toLowerCase() === formData.name_en.trim().toLowerCase()
    );
    if (isDuplicateEn) {
      return toast.error("اسم الفئة بالإنجليزي مكرر بالفعل");
    }

    dispatch(addCategory(formData));
  };

  useEffect(() => {
    if (addSuccessMessage) {
      toast.success("تمت الإضافة بنجاح", {
        onClose: () => {
          dispatch(clearAddCategoryState());
          navigate("/category");
        },
      });
    }
    if (addError) {
      toast.error("لم تتم الإضافة");
    }
  }, [addSuccessMessage, addError, navigate, dispatch]);

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <div style={{ padding: "4px 0", direction: "rtl" }}>
      <style>{`
        .cat-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .cat-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
      `}</style>

      {/* ── Header ─────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 800, color: "#0f172a", fontSize: 20, display: "flex", alignItems: "center", gap: 8 }}>
            <FaLayerGroup style={{ color: "var(--gray-color)" }} /> إضافة فئة جديدة
          </h4>
          <p style={{ margin: "2px 0 0", color: "#64748b", fontSize: 13 }}>تحديد تفاصيل واسم تصنيف المنتجات الجديد</p>
        </div>
        <Link to="/category" className="text-decoration-none">
          <button style={{ display: "flex", alignItems: "center", gap: 7, padding: "9px 18px", borderRadius: 10, border: "1px solid #cbd5e1", background: "#fff", color: "#475569", fontWeight: 700, cursor: "pointer", fontSize: 14 }}>
            <FaArrowLeft size={12} /> العودة
          </button>
        </Link>
      </div>

      {/* ── Form Card ─────────────────────────────────── */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "24px 30px", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label style={labelStyle}>اسم الفئة (عربي) *</label>
              <input
                type="text"
                style={inputStyle}
                name="name_ar"
                value={formData.name_ar}
                onChange={handleChange}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="أدخل الاسم (عربي)"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={labelStyle}>اسم الفئة (إنجليزي) *</label>
              <input
                type="text"
                style={inputStyle}
                name="name_en"
                value={formData.name_en}
                onChange={handleChange}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="أدخل الاسم (إنجليزي)"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={labelStyle}>الحالة *</label>
              <select
                className="cat-custom-select"
                name="status"
                value={formData.status ? String(formData.status) : ""}
                onChange={handleChange}
                required
              >
                <option value="" disabled>اختر الحالة</option>
                <option value="1">نشط</option>
                <option value="0">غير نشط</option>
              </select>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, borderTop: "1px solid #f1f5f9", marginTop: 20, paddingTop: 20 }}>
            <button type="button" onClick={() => navigate("/category")} style={{ padding: "9px 22px", borderRadius: 9, border: "1px solid #cbd5e1", background: "#fff", color: "#475569", fontWeight: 700, cursor: "pointer" }}>إلغاء</button>
            <button type="submit" disabled={addLoading} style={{ padding: "9px 28px", borderRadius: 9, border: "none", background: "linear-gradient(135deg,var(--main-color),var(--main-light))", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
              {addLoading ? 'جاري الحفظ...' : 'إضافة الفئة'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategory;
